export default __webpack_public_path__ + "static/media/coquinha_gelada.98f56420.jpg";